<ng-template let-modal #selectAdImageModal>
  <div class="news-add-upload p-2 rounded">
    <div>
      <div class="image-to-upload mb-2">
        <ng-container *ngIf="adImageUpload64Data; else selectImageBlock">
          <img [src]="adImageUpload64Data" />
        </ng-container>
        <ng-template #selectImageBlock>
          <div class="d-flex w-100 justify-content-between justify-content-lg-center p-2 select-image-bar h-100 align-items-center">
            <span class="d-flex flex-column align-items-center h-100 justify-content-center px-4" (click)="commonService.clickButton(subregionImageUploadId)">
              <i class="fa fa-image text-center mb-2"></i>
              Select an image
            </span>
          </div>
        </ng-template>
      </div>
    </div>
    <input type="file" accept="image/*" (change)="onAdImageSelect($event)" [id]="subregionImageUploadId" class="d-none" />

    <div class="w-100 d-flex justify-content-start align-items-center mt-2">
      <button class="btn btn-outline-primary" (click)="uploadAdImage()"><i class="fa fa-save"></i> Save</button>
    </div>
  </div>
</ng-template>

<!-- <div class="single-new" *ngIf="article?.title">
  <h1 class="d-none">{{ article?.title }}</h1>
  <div class="container">
    <div style="display: flex; align-items: center; gap: 0.25rem; margin-bottom: 0.5rem;">
      <div class="back-button-section">
        <button class="back-button" (click)="goBack()"><i class="fa fa-chevron-left"></i></button>
      </div>
      <app-breadcrumb
        *ngIf="article && article.slug"
        [data]="[
        {
          name: 'News',
          link: '/news',
          active: true,
        },
        {
          name: article.title,
          link: '/news/' + article.slug,
          active: true,
        },
      ]"
      ></app-breadcrumb>
    </div>

    <div class="single-new__header">
      <div class="single-new__header--main-card">
        <div class="float-heart" (click)="likeHandle(article?.id, article)">
          <span>{{ article?.bottomBannerLikes?.length }}</span>
          <i class="fa-{{ hasChecked(article?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
        </div>

        <img loading="lazy" [src]="imgUrl + article.image" class="single-new__header--img" [alt]="'News Image ' + article.title" (error)="commonService.handleError($event)" />
        <div class="bg-glass">
          <div class="bg-glass__title">
            <div class="options">
              <div class="icon" aria-hidden="true" id="list-new" *ngIf="isLogin" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
              </div>
              <div class="dropdown-menu" aria-labelledby="list-new">
                <a class="dropdown-item" *ngIf="appUserId == article?.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')" (click)="editBlog(article)">Edit</a>
                <a class="dropdown-item" *ngIf="appUserId == article?.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')" (click)="deleteBlog(article.id)">Delete</a>
                <a *ngIf="roleService?.roles?.permissions?.NEWS_ARTICLE?.includes('ADD')" class="dropdown-item" (click)="openModalRelate()">Add Relate Article</a>
                <a *ngIf="roleService?.roles?.permissions?.NEWS_ARTICLE?.includes('REMOVE') && article?.related?.length > 0" class="dropdown-item" (click)="openModalRelate(true)">Remove Relate Article</a>
              </div>
            </div>
            <div class="single-new__header--title">{{ article.title }}</div>
            <div class="ml-2 reading-diamond" *ngIf="article?.memberNewsDiamond?.diamonds"><img loading="lazy" src="../../../../assets/images/diamond.png" style="height: 20px; margin-right: 2px" class="rounded" />{{ article?.memberNewsDiamond?.diamonds }}</div>
            <div class="d-flex justify-content-between">
              <div class="single-new__header--details">
                <div class="item">
                  <i class="fa fa-clock"></i>
                  <span>{{ convertDate(article.created) }}</span>
                </div>
                <div class="item">
                  <i class="fa fa-user"></i>
                  <span>
                    {{ article.author != "" ? article.author : "Anonymous" }}
                  </span>
                </div>
                <div class="item">
                  <i class="fa fa-eye"></i>
                  <span>
                    {{ article.viewCount }}
                  </span>
                </div>
              </div>

              <div class="d-flex flex-column">
                <div class="single-new__header--cate">
                  <span>{{ article.category }}</span>
                </div>

                <div class="text-muted">
                  <i class="fa fa-pencil-alt"></i>
                  <span class="text-muted">
                    {{ formatEditedDate(article.updated) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <div class="d-flex" style="gap: 1rem">
          <div class="text-muted">
            <i class="fa fa-pencil-alt"></i>
            <span class="text-muted">
              {{ formatEditedDate(article.updated) }}
            </span>
          </div>
          <div class="options">
            <div class="icon" aria-hidden="true" id="list-new" *ngIf="isLogin" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="list-new">
              <a class="dropdown-item" *ngIf="appUserId == article?.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')" (click)="editBlog(article)">Edit</a>
              <a class="dropdown-item" *ngIf="appUserId == article?.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')" (click)="deleteBlog(article.id)">Delete</a>
            </div>
          </div>
        </div>
        <div class="single-new__header--title">{{ article.title }}</div>
        <div class="single-new__header--details">
          <div class="item">
            <i class="fa fa-clock"></i>
            <span>{{ convertDate(article.created) }}</span>
          </div>
          <div class="item">
            <i class="fa fa-user"></i>
            <span>
              {{ article.author != "" ? article.author : "Anonymous" }}
            </span>
          </div>
          <div class="item">
            <i class="fa fa-eye"></i>
            <span>
              {{ article.viewCount }}
            </span>
          </div>
        </div>
      </div>
      <app-carousel-mini-card *ngIf="article?.related?.length > 0" [data]="article?.related"></app-carousel-mini-card>
      <ng-container *ngFor="let child of article?.related">
        <h3 class="d-none" *ngIf="child?.title">{{ child.title }}</h3>
      </ng-container>
    </div>
    <div class="row">
      <div class="news-and-forum-smaller w-100 justify-content-start" style="display: flex">
        <app-my-carousel-swiper [config]="middleCaraouseConfig" [ngClass]="{ 'col-md-8': tableOfContents?.length > 0 }">
          <div class="swiper-slide w-100">
            <app-forum-list type="news" [forums]="newsForums" [modifyWhenOnSmallDevice]="true" (reloadForums)="reloadForums()" [pageId]="article?.id"></app-forum-list>
          </div>
          <div class="swiper-slide w-100">
            <div class="single-new__body content w-100">
              <div class="single-new__body--description" [innerHTML]="articleText"></div>
            </div>
            <div class="single-new__body" *ngIf="tableOfContents?.length > 0">
              <div class="single-new__body--description">
                <div class="text-black" style="font-weight: 600; font-size: 1.2rem">Table of Contents</div>
                <div class="single-new__table-of-content" (click)="goToHeader(item)" *ngFor="let item of tableOfContents">
                  <div [innerHTML]="item"></div>
                </div>
              </div>
            </div>
          </div>
        </app-my-carousel-swiper>
      </div>
      <div [ngClass]="{ 'col-md-8': tableOfContents?.length > 0 }" class="position-relative news-and-forum-desktop">

        <app-forum-list type="news" [modifyWhenOnSmallDevice]="true" [forums]="newsForums" (reloadForums)="reloadForums()" [pageId]="article?.id"></app-forum-list>

        <div class="single-new__body content">
          <div class="single-new__body--description" [innerHTML]="article.text"></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="single-new__body news-and-forum-desktop" *ngIf="tableOfContents?.length > 0">
          <div class="single-new__body--description" style="padding: 1rem">
            <div class="text-black" style="font-weight: 600; font-size: 1.2rem">Table of Contents</div>
            <div class="single-new__table-of-content" (click)="goToHeader(item)" *ngFor="let item of tableOfContents">
              <div [innerHTML]="item"></div>
            </div>
          </div>
        </div>

        <div class="d-none comment">
          <app-marketplace #marketplace [share]="true"></app-marketplace>
        </div>

        <div class="d-flex flex-column justify-content-center align-items-center my-2" *ngIf="isUserAnAdmin || attachedProducts?.length">
          <p class="w-100 text-center font-bold mb-2 p-2" style="color: var(--primary); font-size: 1.1rem">More Products</p>
          <div class="attached-products comment">
            <common-product-card-view [list]="product" *ngFor="let product of attachedProducts"
            (view)="openProduct($event)" class="mb-2" [isCommunityProduct]="true"></common-product-card-view>
          </div>
          <button (click)="openAttachProduct()" *ngIf="isUserAnAdmin" class="mt-2 btn btn-sm btn-outline-primary">Attach Product +</button>
        </div>

        <img [src]="imgUrl + article?.adImage" *ngIf="article?.adImage" width="100%" class="mt-3 ad-image rounded" />
        <button class="btn btn-outline-primary mt-2" *ngIf="isUserAnAdmin" (click)="openSelectAdImageModal()">Upload Ad Image</button>
      </div>
    </div>
  </div>
</div> -->

<div class="single-news" *ngIf="article?.title">
  <div class="single-news__breadcrumb">
    <div class="back-button-section">
      <button class="back-button" (click)="goBack()"><i class="fa fa-chevron-left"></i></button>
    </div>
    <app-breadcrumb
      *ngIf="article && article.slug"
      [data]="[
        {
          name: 'News',
          link: '/news',
          active: true,
        },
        {
          name: article.title,
          link: '/news/' + article.slug,
          active: true,
        },
      ]"
    ></app-breadcrumb>
  </div>
  <div class="single-news__header">
    <img loading="lazy" [src]="imgUrl + article.image" class="single-news__header--img" [alt]="'News Image ' + article.title" (error)="commonService.handleError($event)" />
    <div class="container">
      <h1 class="single-news__header--title">{{ article.title }}</h1>
      <div class="single-news__header--main-card">
        <div class="user">
          <div class="icon">
            <i class="fa fa-user"></i>
          </div>
          <div>
            <div class="name">{{ article.author != "" ? article.author : "Anonymous" }}</div>
            <div class="details">
              <div class="item">
                <span style="color: var(--primary)">{{ article.category }}</span>
              </div>
              <div class="item" *ngIf="article?.memberNewsDiamond?.diamonds">
                <img loading="lazy" src="../../../../assets/images/diamond.png" style="height: 20px" />
                <span>{{ article?.memberNewsDiamond?.diamonds }}</span>
              </div>
              <div class="item">
                <i class="fa fa-pencil-alt"></i>
                <span>{{ formatEditedDate(article.updated) }}</span>
              </div>
              <div class="item">
                <i class="fa fa-clock"></i>
                <span>{{ convertDate(article.created) }}</span>
              </div>
              <div class="item">
                <i class="fa fa-eye"></i>
                <span>
                  {{ article.viewCount }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="float-heart" (click)="likeHandle(article?.id, article)">
          <span>{{ article?.bottomBannerLikes?.length }}</span>
          <i class="fa-{{ hasChecked(article?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
        </div>

        <div class="options">
          <div class="icon" aria-hidden="true" id="list-new" *ngIf="isLogin" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </div>
          <div class="dropdown-menu" aria-labelledby="list-new">
            <a class="dropdown-item" *ngIf="appUserId == article?.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')" (click)="editBlog(article)">Edit</a>
            <a class="dropdown-item" *ngIf="appUserId == article?.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')" (click)="deleteBlog(article.id)">Delete</a>
            <a *ngIf="roleService?.roles?.permissions?.NEWS_ARTICLE?.includes('ADD')" class="dropdown-item" (click)="openModalRelate()">Add Relate Article</a>
            <a *ngIf="roleService?.roles?.permissions?.NEWS_ARTICLE?.includes('REMOVE') && article?.related?.length > 0" class="dropdown-item" (click)="openModalRelate(true)">Remove Relate Article</a>
          </div>
        </div>
      </div>
      <div class="single-news__table d-block d-md-none" *ngIf="tableOfContents?.length > 0">
        <div class="text-black" style="font-weight: 600; font-size: 1.2rem">Table of Contents</div>
        <div class="single-news__table--of-content" (click)="goToHeader(item)" *ngFor="let item of tableOfContents">
          <div [innerHTML]="item"></div>
        </div>
      </div>
    </div>
  </div>
  <app-carousel-mini-card *ngIf="article?.related?.length > 0" [data]="article?.related"></app-carousel-mini-card>
  <div class="container">
    <div>
      <app-forum-list type="news" [forums]="newsForums" [modifyWhenOnSmallDevice]="true" (reloadForums)="reloadForums()" [pageId]="article?.id"></app-forum-list>
      <div class="single-news__body content">
        <!-- <div class="single-news__body--description" [innerHTML]="articleText"></div> -->
        <div class="single-news__body--description" [innerHTML]="article?.text"></div>
      </div>
      <div class="single-news__table d-none d-md-block" *ngIf="tableOfContents?.length > 0">
        <div class="text-black" style="font-weight: 600; font-size: 1.2rem">Table of Contents</div>
        <div class="single-news__table--of-content" (click)="goToHeader(item)" *ngFor="let item of tableOfContents">
          <div [innerHTML]="item"></div>
        </div>
      </div>
    </div>
    <div>
      <!-- <div class="d-flex flex-column justify-content-center align-items-center my-2" *ngIf="isUserAnAdmin || attachedProducts?.length">
          <p class="w-100 text-center font-bold mb-2 p-2" style="color: var(--primary); font-size: 1.1rem">More Products</p>
          <div class="attached-products">
            <common-product-card-view [list]="product" *ngFor="let product of attachedProducts"
            (view)="openProduct($event)" class="mb-2" [isCommunityProduct]="true"></common-product-card-view>
          </div>
          <button (click)="openAttachProduct()" *ngIf="isUserAnAdmin" class="mt-2 btn btn-sm btn-outline-primary">Attach Product +</button>
        </div> -->

      <img [src]="imgUrl + article?.adImage" *ngIf="article?.adImage" width="100%" class="mt-3 ad-image rounded" />
      <button class="btn btn-outline-primary mt-2" *ngIf="isUserAnAdmin" (click)="openSelectAdImageModal()">Upload Ad Image</button>
    </div>
  </div>
</div>

<app-form-new #formNew (initData)="initData($event)"></app-form-new>
